import { PQModal } from "../../common/components/QualificationMonthModal/QualificationMonthModal";
import { useGetQMonthHistoryQuery } from "../../services/QMonthHistory/qMonthHistoryAPI";
import { useAppSelector } from "../../store";
import { storedLocale } from "../Authentication/util";

export type Props = {
  isModalOpen: boolean;
  onClose: () => void;
  header: "currentYtd" | "previousYtd" | "monthlyGpv";
  period: string;
};

export const YTDQMonthModal = ({ isModalOpen, onClose, header, period }: Props) => {
  const user = useAppSelector((state) => state.boot?.user);
  const boot = useAppSelector(({ boot }) => boot);
  const locale = storedLocale();

  const { isFetching, isError, data, refetch } = useGetQMonthHistoryQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: period,
      IsoCountryCode: user.isoCountryCode,
      IsoCurrencyCode: boot.shellConfig.isoCurrencyCode,
      Locale: locale,
    },
    {
      skip: !isModalOpen,
    },
  );

  return (
    <PQModal
      toggleModal={onClose}
      displayModal={isModalOpen}
      pqMonths={data?.months || []}
      header={header}
      performanceYear={period}
      isLoading={isFetching}
      showBooster={false}
      errorStatus={isError}
      refetchCallback={refetch}
      qualificationType="q"
    />
  );
};
